export default __webpack_public_path__ + "static/media/thumbnail.7c537715.png";